(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bomben2/assets/javascripts/my-bets-route.js') >= 0) return;  svs.modules.push('/modules/bomben2/assets/javascripts/my-bets-route.js');
"use strict";

const ProtectedRoute = svs.components.lbUtils.protectedRoute.ProtectedRoute;
const _ReactRouterDOM = ReactRouterDOM,
  Route = _ReactRouterDOM.Route,
  Switch = _ReactRouterDOM.Switch;
const tipsenLazy = svs.components.tipsen.tipsenLazy.tipsenLazy;
const TipsenModuleGameUrl = svs.components.sport.tipsenShared.TipsenModuleGameUrl;
const RouteMyBetsWagerFallbackBomben = svs.components.tipsen.modularBase.RouteMyBetsWagerFallbackBomben;

const LazyRouteMyBets = tipsenLazy('route-my-bets', () => svs.bomben2.components.RouteMyBets, {
  fallback: () => null
});
const LazyRouteMyBetsWager = tipsenLazy('route-my-bets-wager', () => svs.bomben2.components.routeMyBetsWager.RouteMyBetsWager, {
  fallback: RouteMyBetsWagerFallbackBomben
});
const allowedRoles = ['Player', 'CustomerService'];
const MyBetsRoute = () => React.createElement(ProtectedRoute, {
  roles: allowedRoles
}, React.createElement(Switch, null, React.createElement(Route, {
  component: LazyRouteMyBetsWager,
  path: "/".concat(TipsenModuleGameUrl.MY_BETS, "/:wagerId(\\d+)")
}), React.createElement(Route, {
  component: LazyRouteMyBets
})));
setGlobal('svs.bomben2.MyBetsRoute', MyBetsRoute);

 })(window);